import "../projects.css";
import { ArrowRightUp } from "@icon-park/react";

function Collide() {
  return (
    <div className="project-container">
      {/* Hero Banner */}
      <div className="banner">
        <img
          src="/assets/projects/collide3.png"
          alt="Collide Project"
          className="banner-image"
        />
      </div>

      {/* Project Header */}
      <div className="project-header">
        <h1 className="project-title">
          <a href="https://interventions.design/" target="_blank" rel="noopener noreferrer" className="link-style" style={{ textDecoration: "none", color: "inherit" }}>
            Collide <ArrowRightUp theme="outline" size="24" fill="currentColor" />
          </a>
        </h1>
        <p className="project-subtitle">
          An interactive, animated website for Scout's 7th annual design conference, built by a team of 4 developers in under two months.
        </p>
        <div className="badge-container">
          <span className="badge">Animation</span>
          <span className="badge">Development</span>
          <span className="badge">TypeScript</span>
          <span className="badge">GSAP</span>
        </div>
      </div>

      {/* Overview Section - 3 Columns */}
      <div className="project-overview">
        <div className="overview-3col">
          <div className="overview-col-item">
            <div className="overview-icon">👥</div>
            <h3 className="overview-title">My Role</h3>
            <p className="overview-text">
              Developer on a 4-person tech team. I built scroll-based animations, homepage interactions, and multiple interactive components.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">⏱️</div>
            <h3 className="overview-title">Timeline</h3>
            <p className="overview-text">
              Under two months to design and develop a comprehensive conference website with interactive animations and seamless user experience.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">✨</div>
            <h3 className="overview-title">Key Contributions</h3>
            <ul className="overview-list">
              <li>Homepage scroll-based animations</li>
              <li>Interactive components and transitions</li>
              <li>TypeScript and GSAP implementation</li>
              <li>User-friendly navigation and flow</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Design Challenge Section */}
      <div className="case-study-section">
        <h2 className="section-title">The Challenge</h2>
        <div className="case-study-content">
          <p className="case-study-text">
            Scout's 7th annual design conference needed a website that captured the "Interventions: Collide" theme through <strong className="highlight">interactive</strong>, <strong className="highlight">animated</strong>, and <strong className="highlight">user-friendly</strong> design. The site had to house all conference information while creating an engaging experience that reflected the conference's energy.
          </p>
          <p className="case-study-text">
            With a tight timeline and a small team, we prioritized scroll-based animations and smooth interactions that would make the site memorable for attendees while keeping the core information easily accessible.
          </p>
          <div className="brand-values">
            <h3 className="brand-values-title">What I Focused On</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">🎬</span>
                <div className="value-content">
                  <strong>Scroll Animations</strong>
                  <span className="value-text">Built homepage animations that respond to scroll position, creating a dynamic browsing experience.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">⚡</span>
                <div className="value-content">
                  <strong>Performance</strong>
                  <span className="value-text">Ensured smooth animations and fast load times despite complex interactions.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🎯</span>
                <div className="value-content">
                  <strong>User Experience</strong>
                  <span className="value-text">Balanced visual excitement with clear navigation and accessible information.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Animation Showcase */}
      <div className="case-study-section">
        <div className="case-study-content">
          <div style={{ textAlign: "center", marginBottom: "var(--spacing-lg)" }}>
            <img
              src="/assets/projects/collide-animation.gif"
              alt="Collide scroll animation"
              style={{ maxWidth: "70%", borderRadius: "var(--radius-lg)" }}
            />
          </div>
          <p style={{ textAlign: "center", marginTop: "var(--spacing-md)" }}>
            <a 
              href="https://interventions.design/" 
              target="_blank"
              rel="noopener noreferrer"
              className="link-style"
            >
              View Live Site ↗
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Collide;
